import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import colors from '../Theme/colors';

const premiumPropertyTypes = {
  fillColor: PropTypes.string,
  size: PropTypes.number,
};

type PremiumProperties = InferProps<typeof premiumPropertyTypes> & {
  fillColor?: string;
  size?: number;
};

const Premium = ({
  fillColor,
  size,
}: PremiumProperties) => {
  const sizeValue = size ?? 24;

  return (
    <svg
      viewBox={`0 0 ${sizeValue} ${sizeValue}`}
      width={sizeValue}
      height={sizeValue}
    >
      <title>Premium</title>
      <g
        transform={`scale(${sizeValue / 52} ${sizeValue / 52})`}
      >
        <path
          d="m25,1 6,17h18l-14,11 5,17-15-10-15,10 5-17-14-11h18z"
          fill={fillColor ?? colors.greyDark}
        />
      </g>
    </svg>
  );
};

Premium.propTypes = premiumPropertyTypes;

export default Premium;
